import { Android16 } from 'ui/icons/devices/Android16';
import { Apple16 } from 'ui/icons/devices/Apple16';

export enum SnsPlatform {
  apple = 'APNS',
  appleSandbox = 'APNS_SANDBOX',
  android = 'GCM',
}

export enum UserClientType {
  android = 'Android',
  apple = 'Apple',
  google = 'Google',
  microsoft = 'Microsoft',
  mobile = 'Mobile',
  desktop = 'Desktop',
}

export type Device = {
  platform: SnsPlatform;
  model?: string;
};

export const SNS_PLATFORMS_TO_ICONS = {
  [SnsPlatform.android]: Android16,
  [SnsPlatform.apple]: Apple16,
  [SnsPlatform.appleSandbox]: Apple16,
};

export const SNS_PLATFORMS_TO_DEFAULT_MODEL_NAMES = {
  [SnsPlatform.android]: 'Android Device',
  [SnsPlatform.apple]: 'Apple Device',
  [SnsPlatform.appleSandbox]: 'Apple Device',
};

export const SNS_PLATFORMS_TO_USER_CLIENT_TYPES = {
  [SnsPlatform.android]: UserClientType.android,
  [SnsPlatform.apple]: UserClientType.apple,
  [SnsPlatform.appleSandbox]: UserClientType.apple,
};
